import { render } from "./ProductDetailDialog.vue?vue&type=template&id=5dc3a79a&scoped=true&ts=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=ts"

import "./ProductDetailDialog.vue?vue&type=style&index=0&id=5dc3a79a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc3a79a"]])

export default __exports__